import React from "react"
import { CustomIconsType } from "../types"
import { ProgressBar } from "./generalIcons"

const CUSTOM_ICONS: Record<CustomIconsType, React.FC> = {
  "bar-progress": ProgressBar
}

const getCustomIconComponent = (name: CustomIconsType): React.FC => {
  return CUSTOM_ICONS[name] || null
}

export default getCustomIconComponent
